import request from '@/utils/request'

export function getApp(params) {
  return request({
    url: '/app/find',
    method: 'get',
    params,
  })
}

export function setupApp(data) {
  return request({
    url: '/app/setup',
    method: 'post',
    data,
  })
}

export function getWechatConfig(params) {
  return request({
    url: '/super/getWechatConfig',
    method: 'get',
    params,
  })
}

export function setupWechatWidget(data) {
  return request({
    url: '/super/setupWechatWidget',
    method: 'post',
    data,
  })
}

export function setupWechatWap(data) {
  return request({
    url: '/super/setupWechatWap',
    method: 'post',
    data,
  })
}

export function getWePayConfig(params) {
  return request({
    url: '/super/getWePayConfig',
    method: 'get',
    params,
  })
}

export function setupWePay(data) {
  return request({
    url: '/super/setupWePay',
    method: 'post',
    data,
  })
}

export function getBangWeiConfig(params) {
  return request({
    url: '/super/getBangWeiConfig',
    method: 'get',
    params,
  })
}

export function setupBangWei(data) {
  return request({
    url: '/super/setupBangWei',
    method: 'post',
    data,
  })
}

export function getXiRuanXcsConfig(params) {
  return request({
    url: '/super/getXiRuanXcsConfig',
    method: 'get',
    params,
  })
}

export function setupXiRuanXcs(data) {
  return request({
    url: '/super/setupXiRuanXcs',
    method: 'post',
    data,
  })
}

export function getFeedbackTags(params) {
  return request({
    url: '/app/findFeedbackTagList',
    method: 'get',
    params,
  })
}

export function getAllFeedbackTags(params) {
  return request({
    url: '/app/findFeedbackTagAll',
    method: 'get',
    params,
  })
}

export function addFeedbackTag(data) {
  return request({
    url: '/app/createFeedbackTag',
    method: 'post',
    data,
  })
}

export function editFeedbackTag(data) {
  return request({
    url: '/app/updateFeedbackTag',
    method: 'post',
    data,
  })
}

export function delFeedbackTag(data) {
  return request({
    url: '/app/removeFeedbackTag',
    method: 'post',
    data,
  })
}
//修改密码
export function changePassword(data) {
  return request({
    url: '/app/password',
    method: 'post',
    data,
  })
}

//设置配置信息
export function setupConfig(data) {
    return request({
        url: '/app/setupConfig',
        method: 'post',
        data,
    })
}

//获取配置信息
export function getConfig(params) {
    return request({
        url: '/app/getConfig',
        method: 'get',
        params,
    })
}

// 新增OpenApiKey
export function createOpenApiKey(data) {
    return request({
        url: '/people/createOpenApiKey',
        method: 'post',
        data,
    })
}

// 修改OpenApiKey
export function updateOpenApiKey(data) {
    return request({
        url: '/people/updateOpenApiKey',
        method: 'post',
        data,
    })
}

// 删除OpenApiKey
export function removeOpenApiKey(data) {
    return request({
        url: '/people/removeOpenApiKey',
        method: 'post',
        data,
    })
}

//获取配置信息
export function findOpenApiKeyList(params) {
    return request({
        url: '/people/findOpenApiKeyList',
        method: 'get',
        params,
    })
}
// guanjiapo
export function getGuanJiaPoConfig(params) {
  return request({
      url: '/super/getGuanJiaPoConfig',
      method: 'get',
      params,
  })
}
// 设置管家婆：post super/setupGuanJiaPo，参数：
// config.url // 服务器地址
// config.appKey // appKey
// config.appSecret // appSecret
// config.signKey // signKey
export function setupGuanJiaPo(data) {
  return request({
      url: '/super/setupGuanJiaPo',
      method: 'post',
      data,
  })
}
// 刷新管家婆Token：post super/setupGuanJiaPo，参数：
// config.url // 服务器地址
// config.appKey // appKey
// config.appSecret // appSecret
// config.signKey // signKey
export function getGuanJiaPoAuthUrl(params) {
  return request({
      url: '/super/getGuanJiaPoAuthUrl',
      method: 'get',
      params,
  })
}
export function refreshGuanJiaPoToken(data) {
  return request({
      url: '/super/refreshGuanJiaPoToken',
      method: 'post',
      data,
  })
}
// 快递100 获取快递100配置：get super/getKuaiDi100Config,参数：无
export function getKuaiDi100Config(params) {
  return request({
      url: '/super/getKuaiDi100Config',
      method: 'get',
      params,
  })
}
// 设置
// 设置快递100：post super/setupKuaiDi100,参数：
// config.customer // customer
// config.key // key
export function setupKuaiDi100(data) {
  return request({
      url: '/super/setupKuaiDi100',
      method: 'post',
      data,
  })
}
//根据商户号选择终端
//获取终端
export function findEndpointList(params) {
  return request({
      url: '/super/findEndpointList',
      method: 'get',
      params,
  })
}
//打印机
// 新增打印机：printer/create，参数：
// branchId // 门店ID
// title // 标题
// apiUrl // 服务器地址
// user // 应用ID
// usecret // 密钥
// ukey // 令牌
// text // 备注
// order // 排序
export function createPrinter(data) {
  return request({
      url: '/printer/create',
      method: 'post',
      data,
  })
}
// 修改打印机：printer/update，参数：
// printerId // 打印机ID
// branchId // 门店ID
// title // 标题
// apiUrl // 服务器地址
// user // 应用ID
// usecret // 密钥
// ukey // 令牌
// text // 备注
// order // 排序
export function updatePrinter(data) {
  return request({
      url: '/printer/update',
      method: 'post',
      data,
  })
}
// 删除打印机：printer/remove，参数：
// printerId // 打印机ID
export function removePrinter(data) {
  return request({
      url: '/printer/remove',
      method: 'post',
      data,
  })
}
// 获取单个打印机：printer/find, 参数：
// printerId // 打印机ID
export function findPrinter(params) {
  return request({
      url: '/printer/find',
      method: 'get',
      params,
  })
}
// 获取打印机列表：printer/findList, 参数：
// page
// size
// keyword // 搜索标题
// branchId // 门店ID
export function findPrinterList(params) {
  return request({
      url: '/printer/findList',
      method: 'get',
      params,
  })
}
// 获取所有打印机：printer/findAll, 参数：
// keyword // 搜索标题
// branchId // 门店ID
export function findPrinterAll(params) {
  return request({
      url: '/printer/findAll',
      method: 'get',
      params,
  })
}
// 绑定打印机：post printer/bind, 参数：
// printerId
export function bindPrinter(data) {
  return request({
      url: '/printer/bind',
      method: 'post',
      data,
  })
}
// 解绑打印机：post printer/unBind, 参数：
// printerId
export function unBindPrinter(data) {
  return request({
      url: '/printer/unBind',
      method: 'post',
      data,
  })
}
// 打印测试：post printer/print，参数：
// printerId
// content // 打印内容
export function testPrinter(data) {
  return request({
      url: '/printer/print',
      method: 'post',
      data,
  })
}